import {Meals as MealsComponent} from './Meals'
import {Qr as QrComponent} from './Qr'

export const Meals = MealsComponent;
export const Qr = QrComponent;